<template>
    <v-container fluid>
        <v-row
            align="center"
            no-gutters
        >
            <v-col
                cols="12"
                justify="center"
                sm="8"
            >
                <v-subheader>
                    <h2>Patients ({{ totalMatches }})</h2>
                </v-subheader>
                <!--<v-subheader>
                    <h5>
                        Accounts excluded: Accepted, Rejected
                        <br />Adjust filter for inclusion
                    </h5>
                </v-subheader>-->
            </v-col>
            <v-col
                cols="12"
                lg="4"
                sm="6"
            >
                <v-text-field
                    @click:clear="setSearch('')"
                    @input="setSearch"
                    clearable
                    label="Search"
                    prepend-icon="mdi-magnify"
                    single-line
                />
            </v-col>
            <v-col
                class="text-right"
                cols="12"
                sm="4"
            >
            </v-col>
        </v-row>
        <v-container class="pb-10">
            <v-row
                justify="center"
                v-if="patientsWithInfo === null"
            >
                <v-col
                    :key="i"
                    cols="12"
                    v-for="i in 6"
                >
                    <v-skeleton-loader
                        elevation="4"
                        type="card"
                    ></v-skeleton-loader>
                </v-col>
            </v-row>
            <v-row
                justify="center"
                v-else
            >
                <v-col
                    :key="patientWithInfo.entity.id"
                    cols="12"
                    v-for="patientWithInfo in patientsWithInfo"
                >
                    <v-card
                        class="incident-card fill-height"
                        elevation="4"
                        style="overflow: hidden"
                        @click="loadPatientForm(patientWithInfo.entity.id)"
                    >
                        <v-card-subtitle>
                            Name: {{ patientWithInfo.entity.identity.name }}; Surname: {{ patientWithInfo.entity.identity.surname }}; IdentityNumber: {{patientWithInfo.entity.identity.identificationNumber}}; Incident#: {{patientWithInfo.entity.incidentId}}
                            <br>
                        </v-card-subtitle>
                        <v-card-text>                       

                            <v-chip
                                class="ma-1"
                                color="grey"
                                dark
                                small
                                v-show="patientWithInfo.entity.isAdmitted"
                            >Admitted</v-chip>

                            <v-chip
                                class="ma-1"
                                color="grey"
                                dark
                                small
                                v-show="patientWithInfo.entity.isVerified"
                            >Verified</v-chip>

                            <v-chip
                                class="ma-1"
                                color="grey"
                                dark
                                small
                                v-show="patientWithInfo.entity.isDischarged"
                            >Discharged</v-chip>

                            <v-chip
                                class="ma-1"
                                color="grey"
                                dark
                                small
                                v-show="patientWithInfo.entity.isFraudulent"
                            >Fraudulent</v-chip>

                            <v-chip
                                class="ma-1"
                                color="grey"
                                dark
                                small
                                v-show="patientWithInfo.entity.isSuspended"
                            >Suspended</v-chip>

                            <v-chip
                                class="ma-1"
                                color="grey"
                                dark
                                small
                                v-show="patientWithInfo.entity.isFinalised"
                            >Finalised</v-chip>


                        </v-card-text>
                                                <v-btn
                            @click.stop="
                        $router.push({
                            name: 'Incidents',
                            params: {
                                incidentId: patientWithInfo.entity.incidentId
                            },
                        })
                    "
                            class="text-none"
                            color="secondary darken-1"
                            text
                        >Incident #{{patientWithInfo.entity.incidentId}}</v-btn>
                    </v-card>
                </v-col>
            </v-row>
        </v-container>
        <!--PAGINATION SECTION-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-->
        <v-pagination
            :length="pagesCount"
            @input="paginationDebounce(500)"
            class="pagination-bar base-background"
            total-visible="7"
            v-model="pageNo"
            v-show="pagesCount > 1"
        ></v-pagination>
                        <v-dialog
            transition="scroll-x-reverse-transition"
            v-model="patientFormVisible"
            width="500px"
        >
            <PatientForm 
                    :key="patientFormPatientId"
                    :patient-id="patientFormPatientId"
                    @close="closePatientForm"
                     />
        </v-dialog>
    </v-container>
</template>

<script>
import uuid4 from "../helpers/uuid4";
import PatientForm from "../components/forms/PatientForm.vue";

export default {
    name: "Patients",
    props: [
        "providerId",
        "areaId",
        "patientAgedDaysMin",
        "patientAgedDaysMax",
        "mcaIsFraudulent",
        "mcaIsFinalised",
        "mcaIsSuspended",
        "mcaIsAdmitted",
        "mcaIsVerified",
    ],
    data: function() {
        return {
            //main data
            patientsWithInfo: null,
            accountDisciplines: null,
            //pagination
            pageNo: 1,
            pageSize: 100,
            pagesCount: 0,
            searchString: "",
            orderBy: "",
            sortOrder: 0,
            paginationTimeout: null,
            requestId: uuid4(),
            totalMatches: null,

            patientFormPatientId: -1,
            patientFormVisible: false,
            //
        };
    },
    mounted: async function() {
        this.getAccounts();
    },
    components: {
        PatientForm
        //
    },
    computed: {
        //
    },
    methods: {
        async getAccounts() {
            var requestId = (this.requestId = uuid4());

            var urlParameters = {
                pageNo: this.pageNo,
                pageSize: this.pageSize,
                searchString: this.searchString,
                orderBy: this.orderBy,
                sortOrder: this.sortOrder,
                        patientAgedDaysMin:
                            this.patientAgedDaysMin > -1
                                ? this.patientAgedDaysMin
                                : null,
                        patientAgedDaysMax:
                            this.patientAgedDaysMax > -1
                                ? this.patientAgedDaysMax
                                : null,
                providerId: this.filterProviderId
                            ? this.filterProviderId
                            : null,
                areaId: this.filterAreaId ? this.filterAreaId : null,
                        mcaIsFraudulent:
                            this.mcaIsFraudulent !== undefined
                                ? this.mcaIsFraudulent
                                : false,
                        mcaIsFinalised:
                            this.mcaIsFinalised !== undefined
                                ? this.mcaIsFinalised
                                : false,
                        mcaIsSuspended:
                            this.mcaIsSuspended !== undefined
                                ? this.mcaIsSuspended
                                : false,
                        mcaIsAdmitted:
                            this.mcaIsAdmitted !== undefined
                                ? this.mcaIsAdmitted
                                : false,
                        mcaIsVerified:
                            this.mcaIsVerified !== undefined
                                ? this.mcaIsVerified
                                : null,
                
            };

            var patientsResponse = await this.$store.dispatch("patients/getpage", {
                id: this.filterAccountId,
                urlParameters,
                requestId: requestId
            });

            if (this.requestId == patientsResponse.requestId) {
                //patientsResponse.data.page.forEach(x =>this.accountApplyDisciplineName(x.entity));
                this.patientsWithInfo = patientsResponse.data.page;
                this.totalMatches = patientsResponse.data.total;
                this.pagesCount = Math.ceil(
                    patientsResponse.data.total / this.pageSize
                );
            }
        },
        paginationDebounce(debounceTime) {
            if (this.patientsWithInfo !== null) this.patientsWithInfo = null;
            clearTimeout(this.paginationTimeout);
            this.paginationTimeout = setTimeout(this.getAccounts, debounceTime);
        },
                setSearch(value) {
            this.searchString = value;
            this.paginationDebounce(1000);
        },
        loadPatientForm(patientId) {
            this.patientFormPatientId = patientId;
            this.patientFormVisible = true;
        },
        closePatientForm() {
            this.paginationDebounce(0);
            this.patientFormPatientId = -1;
            this.patientFormVisible = false;
        },
    }
};
</script>

<style lang="stylus" scoped>
.incident-card {
    /* background: linear-gradient(45deg, rgba(127,127,127,0.1), transparent,rgba(127,127,127,0.1)) */
    .center-content {
        background-color: rgba(127, 127, 127, 0.15);
    }
}

.theme--dark {
    .patient-panel {
        .v-card {
            background-color: rgba(127, 127, 127, 0.1);
        }
    }
}

.pagination-bar {
    // position: fixed;
    bottom: 0;
    margin: auto;
    left: 0;
    right: 0;
    padding-bottom: 0.1rem;
    padding-top: 0.1rem;
    /*
    border-top-left-radius: 4px;
    border-top-right-radius: 4px;
    border:1px solid rgba(127, 127, 127, 0.2)
    */
}

.theme--light {
    .base-background {
        background: #FFFFFF;
    }
}

.theme--dark {
    .base-background {
        background: #121212;
    }
}
</style>
